import React, { useState } from "react";
import ReactDOM from "react-dom";
import "../styles/passwordReset.css";
import { resetCustomerPassword } from "../services/customerPasswordResetService";

function PasswordReset({ onClose }) {

  const [username, setUsername] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setError("");

    if (!username || !currentPassword || !newPassword || !confirmPassword) {
      setError("All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (newPassword.length < 4) {
      setError("Password must be at least 4 characters");
      return;
    }

    try {
      setLoading(true);

      const res = await resetCustomerPassword({
        username,
        password: currentPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      });

      alert(res.message || "Password changed successfully ✅");

      onClose();

    } catch (err) {
      setError(err.message || "Password change failed ❌");
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
  <div className="pr-overlay" onClick={onClose}>

    <div className="pr-modal" onClick={(e) => e.stopPropagation()}>

      {/* HEADER */}
      <div className="pr-header">
        <h5>Password Reset</h5>
        <button className="btn-close" onClick={onClose}></button>
      </div>

      {/* BODY */}
      <div className="pr-body">

        <div className="mb-3">
          <label className="form-label">Username</label>
          <input
            className="form-control"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Current Password</label>
          <input
            type="password"
            className="form-control"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">New Password</label>
          <input
            type="password"
            className="form-control"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Confirm Password</label>
          <input
            type="password"
            className="form-control"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>

        {error && <div className="alert alert-danger">{error}</div>}

      </div>

      {/* FOOTER */}
      <div className="pr-footer">
        <button className="btn btn-secondary" onClick={onClose}>
          Cancel
        </button>

        <button
          className="btn btn-primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Updating..." : "Reset Password"}
        </button>
      </div>

    </div>

  </div>,
  document.body
);
}

export default PasswordReset;